import { MedicalTerm } from '../../lib/types/models/medical-terms/medical-term'
import { MedicalTermInput } from '../../lib/types/models/medical-terms/medical-term-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createMedicalTerm(data: MedicalTermInput) {
  return restApiClient
    .url(constructApiUrl(API.medicalTerms.create.url, null))
    .post<MedicalTerm>(data)
}
